export default (api) => ({
  fetch: (params) => api.$get("/alerts", { params }),

  fetchByAgency: (agencyId, params) => api.$get(`/agencies/${agencyId}/alerts`, { params }),

  fetchDqlFields: () => api.$get("/alerts/dql/fields"),

  search: (params, body) => api.$post("/alerts/search", body, { params }),

  searchByAgency: (agencyId, params, body) =>
    api.$post(`/agencies/${agencyId}/alerts/search`, body, { params }),

  patch: (id, body) => api.$patch(`/alerts/${id}`, body),

  bulkUpdate: (body) => api.$post("/alerts/bulk/update-status", body),

  preparecsv: (params) => api.$get("/alerts/preparecsv", { params }),

  preparecsvByAgency: (agencyId, params) =>
    api.$get(`/agencies/${agencyId}/alerts/preparecsv`, { params }),
});
